import React from 'react'
import PropTypes from 'prop-types'
// import noop from 'lodash/noop'
import { Circles } from 'react-loader-spinner'
import { EMPTY_OBJECT } from '../../constants/globalConstants'



const PriceBreackup = (props) => {
  // const {BookingEdit,priceDetails,timeupdate,loaderPrice,promoCodeApply,discount}=props
  const { priceDetails, loaderPrice, promoCodeApply, discount, promoRes, selectedFacilityData, isVehicleOversize } = props
  return (
    <div className='mt-2'>
      {loaderPrice ? (
        <span
          className="mx-auto my-5 d-block"
          style={{ width: '30px' }}
        >
          <Circles
            height="20"
            width="20"
            style={{ display: 'inline-block' }}
            color="#000"
            ariaLabel="circles-loading"
            visible={true}
          />
        </span>
      ) : priceDetails?.parking_amount != 'N/A' && !isNaN(Number(priceDetails?.parking_amount)) ? (
        <div className="px-3">
          {selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ? <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Parking Amount</p>{' '}
            <p className="m-0">
              <b>
                $
                {priceDetails?.parking_amount
                  ? isNaN(Number(priceDetails?.parking_amount)) ? 'N/A' : Number(priceDetails?.parking_amount).toFixed(2)
                  : '0.00'}
              </b>
            </p>
          </div> : null}

          {priceDetails?.net_parking_amount > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0">Net Parking Amount</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.net_parking_amount
                    ? isNaN(Number(priceDetails?.net_parking_amount)) ? 'N/A' : parseFloat(priceDetails?.net_parking_amount).toFixed(2)
                    : '0.00'}
                </b>
              </p>
            </div>
          )}
          
          {priceDetails?.tax_fee > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> Tax</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.tax_fee
                    ? isNaN(Number(priceDetails?.tax_fee)) ? 'N/A' : parseFloat(priceDetails?.tax_fee).toFixed(2)
                    : '0.00'}
                </b>
              </p>
            </div>
          )}
          {priceDetails?.surcharge_fee > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> Surcharge Fee</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.surcharge_fee
                    ? parseFloat(priceDetails?.surcharge_fee).toFixed(2)
                    : '0.00'}
                </b>
              </p>
            </div>
          )}
          {((priceDetails?.processing_fee && priceDetails?.processing_fee > 0) || (priceDetails?.additional_fee && priceDetails?.additional_fee > 0)) && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Reservation Fee' : 'Processing Fee'}  </p>{' '}
              <p className="m-0">
                <b>
                  ${Number(Number(priceDetails?.processing_fee) + Number(priceDetails?.additional_fee))?.toFixed(2)}
                  {/* {priceDetails?.processing_fee
                    ? isNaN(Number(priceDetails?.processing_fee)) ? 'N/A' : parseFloat(priceDetails?.processing_fee).toFixed(2)
                    : '0.00'} */}
                </b>
              </p>
            </div>
          )}
          {promoCodeApply && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0">
                <p className='m-0'>{promoRes?.promocode?.discount_type == 'hours' ? `Validated Amount (${promoRes?.discount_in_hours} Hrs Free)` : selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 ? 'Coupon Discount' : 'Discount'} </p>{' '}
                {selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 ? <p className='small'>{priceDetails?.applied_promo_code?.name || priceDetails?.promocode_name ? `(${priceDetails?.applied_promo_code?.name || priceDetails?.promocode_name})` : null}</p> : null}
              </p>
              <p className="m-0">
                <b>- ${parseFloat(discount).toFixed(2)}</b>
              </p>
            </div>
          )}

          {isVehicleOversize && <div className="row">
            <small className="text-danger small col-8 d-block">
              <span className="text-danger small d-block p-0 m-0">(**Oversize Fee Applied)</span>
            </small>
          </div>}



          <div className="d-flex border-top justify-content-between mb-1 pt-2 ">
            <h4 className="font-weight-bold h5 text-primary m-0 ">
              {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Total Due' : 'Amount Due'}
            </h4>
            {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ?
              <h4 className="font-weight-bold h5 text-primary ">
                $
                {priceDetails?.processing_fee
                  ? isNaN(Number(priceDetails?.processing_fee)) ? 'N/A' : Number(priceDetails?.processing_fee).toFixed(2)
                  : '0.00'}{' '}
              </h4>
              :
              <h4 className="font-weight-bold h5 text-primary ">
                $
                {priceDetails?.payable_amount
                  ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : Number(priceDetails?.payable_amount).toFixed(2)
                  : '0.00'}{' '}
              </h4>
            }
          </div>
        </div>
      ) : (
        <div className="px-3">
          <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Parking Amount</p>{' '}
            <p className="m-0">
              <b>{!isNaN(Number(priceDetails?.parking_amount)) ? parseFloat(priceDetails?.parking_amount).toFixed(2) : 'N/A'}</b>
            </p>
          </div>
        </div>
      )
      }
    </div>
  )
}

PriceBreackup.propTypes = {
  loaderPrice: PropTypes.boolean,
  priceDetails: PropTypes.object,
  discount: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  promoCodeApply: PropTypes.boolean,
  timeupdate: PropTypes.boolean,
  BookingEdit: PropTypes.boolean,
  promoRes: PropTypes.object,
  selectedFacilityData: PropTypes.object,
  isVehicleOversize: PropTypes.boolean,
}

PriceBreackup.defaulProps = {
  loaderPrice: false,
  priceDetails: EMPTY_OBJECT,
  discount: '',
  promoCodeApply: false,
  timeupdate: false,
  BookingEdit: false,
  promoRes: EMPTY_OBJECT,
  selectedFacilityData: EMPTY_OBJECT,
  isVehicleOversize: false
}

export default PriceBreackup
